import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useUiStore } from '@/stores/uiStore'
import { SkipLink } from '@/components/ui/SkipLink'

/**
 * Root layout — outermost wrapper for all routes.
 *
 * - Syncs theme class on document.documentElement
 * - Provides skip link for keyboard navigation
 * - Renders children directly (providers are in main.tsx)
 */
export function RootLayout() {
  const theme = useUiStore((s) => s.theme)

  // Sync theme with document
  useEffect(() => {
    const root = document.documentElement
    if (theme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [theme])

  return (
    <div className="h-full">
      <SkipLink />
      <Outlet />
    </div>
  )
}
